/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import h from "../../util/dom-builder.js";
import birdata from "../../api.js";
import util from "../../util/util.js";

export default function createPagedSurveyList(criteria, p, title) {
	var div = h('div');

	function pageControl(pageIndex, pageSize, pageData) {
		var start = (pageIndex * pageSize) + 1;
		var end = start + pageData.surveys.length - 1;

		var pageInfo = util.formatNumber(start) +
			(start != end ? ('–' + util.formatNumber(end)) : '') +
			' of ' + util.formatNumber(pageData.count);

		var items = [];

		if(pageIndex > 0) {
			var prev = h('span', { class: 'link', style: 'margin-right: 0.5em;' }, 'prev');
			prev.addEventListener('click', function() { loadPage(pageIndex - 1, pageSize); });
			items.push(prev);
		}

		var title = h('span', pageInfo);
		items.push(title);

		if(end < pageData.count) {
			var next = h('span', { class: 'link', style: 'margin-left: 0.5em;' }, 'next');
			next.addEventListener('click', function() { loadPage(pageIndex + 1, pageSize); });
			items.push(next);
		}

		return h('div', { style: 'margin-top: 1em;' }, items);
	}

	function loadPage(pageIndex, pageSize) {
		div.innerHTML = 'Loading…';
		var pageDataPromise = birdata.surveys({
			summarize: 'basic_survey_info',
			lat: p.lat,
			lon: p.lon,
			sort: '-start_date',
			offset: pageIndex * pageSize,
			limit: pageSize,
			...criteria
		});

		Promise.all([
			pageDataPromise,
			birdata.lookup()
		]).then(function([pageData, lookup]) {
			div.innerHTML = '';

			div.appendChild(h('h4', title));

			if(p.approx) {
				div.appendChild(h('p', { 'style': 'font-style: italic; margin-bottom: 1em;' }, 'Sensitive survey(s) – approximate location shown'));
			}

			var hasObserver = pageData.surveys.some(function(s) { return s.observer; });
			var hasLocation = pageData.surveys.some(function(s) { return s.survey_point_name; });

			div.appendChild(h('table', { 'class': 'table' }, [
				h('thead',
					h('tr', [
						h('td', 'Date'),
						hasLocation ? h('td', 'Location name') : '',
						h('td', 'Type'),
						hasObserver ? h('td', 'Observer') : ''
					])
				),
				h('tbody',
					pageData.surveys.map(function(survey) {
						var date = util.formatDate(util.parseISODate(survey.start_date));
						var type = lookup.find('survey_type', survey.type).name;

						return h('tr', [
							h('td',
								p.approx ?
									date :
									h('a', { href: 'survey?id=' + survey.id, target: '_blank' }, date)
							),
							hasLocation ? h('td', survey.survey_point_name || '') : '',
							h('td', type),
							hasObserver? h('td', survey.observer || '') : ''
						]);
					})
				)
			]));

			div.appendChild(pageControl(pageIndex, pageSize, pageData));
		}).catch(function(error) {
			console.log(error);
			div.innerHTML = "Failed to load surveys"
		});
	}

	loadPage(0, 100);

	return div;
}
